import './bottomdrawer.css';
import PropTypes from 'prop-types';
import React from 'react';

function BottomDrawer({
  open,
  children
}: {
  open: boolean,
  children: any|null,
}) {
  const drawerStyle = undefined;

  return (
    <div className={open ? 'ifms-bottom-drawer ifms-bottom-drawer-open' : 'ifms-bottom-drawer'} style={drawerStyle}>
      {children}
    </div>
  );
}

BottomDrawer.defaultProps = {
  open: false,
};

BottomDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
};


export default React.memo(BottomDrawer);
